import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AccountSite, IAccountSite, IAccountSitesResponse } from '../../shared/models/account-site.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountSitesService {
  constructor(private readonly httpClient: HttpClient) {}

  getAccountSites(accountId: number): Observable<IAccountSite[]> {
    return this.httpClient
      .get<IAccountSitesResponse>(`${environment.sitemanagement_api_url}/v1/AccountSitesProducts/${accountId}`)
      .pipe(map(({ sites }) => sites.map((site) => new AccountSite(site))));
  }
}
